import React from 'react';
import Header from '../../components/Header/Header';
import IntroSection from '../../components/WelcomeComponents/IntroSection/IntroSection';
import ActionSection from '../../components/WelcomeComponents/ActionSection/ActionSection';
import './WelcomePage.css';
import FeatureGrid from '../../components/WelcomeComponents/FeatureGrid/FeatureGrid';
import PromoVideo from '../../components/PromoVideo/PromoVideo';
import PlansGrid from '../../components/WelcomeComponents/PlansGrid/PlansGrid';

const navLinks = [
];

const WelcomePage = () => {
  return (
    <div>
      <Header navLinks={navLinks} isScrollEffect={false} />
      <IntroSection />
      {/* Promo video */}
      <PromoVideo title="Discover the Power of EDUWaves" />
      <PlansGrid />

      <ActionSection />
    </div>
  );
};

export default WelcomePage;
